import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { yupResolver } from '@hookform/resolvers/yup'

import { Button, Input } from '../../../../../../components/UI'
import DropDown from '../../../../../../components/Input/DropDown'
import ErrorMessageWithExclamation from '../../../../../../components/UI/ErrorMessageWithExclamation'

import {
  selectRole,
  selectUserData,
} from '../../../../../../routing/fetchingfunction/user/user.reducer'

import { useAvailableCategories } from '../../../../../../hooks'

import { QuizTemplateCreateScheme } from '../../../../../../routing/utils/validators'

const MyQuizTemplateCreateForm = ({ quizTemplateData, setStep, setQuizTemplateData }) => {
  const userData = useSelector(selectUserData)
  const role = useSelector(selectRole)

  const {
    formState: { errors },
    setValue,
    handleSubmit,
    register,
    control,
  } = useForm({
    defaultValues: {
      category: quizTemplateData?.category || null,
      quiz_title: quizTemplateData?.quiz_title || '',
      due_date: quizTemplateData?.due_date
        ? moment(quizTemplateData.due_date)
        : moment().add(1, 'day'),
    },
    resolver: yupResolver(QuizTemplateCreateScheme),
  })

  const { formattedPassedCategories } = useAvailableCategories('passed')

  const handleFormSubmit = (data) => {
    setStep(2)
    setQuizTemplateData({
      ...(quizTemplateData || {}),
      ...data,
      tutor: userData.pk || userData.id,
      due_date: moment(data.due_date).format('YYYY-MM-DD'),
    })
  }

  useEffect(() => {
    if (quizTemplateData) {
      setValue('category', quizTemplateData.category)
      setValue('quiz_title', quizTemplateData.quiz_title)

      if (quizTemplateData.due_date) {
        setValue('due_date', moment(quizTemplateData.due_date))
      }
    }
  }, [quizTemplateData])

  return (
    <form className="w-full flex flex-col" onSubmit={handleSubmit(handleFormSubmit)}>
      <div className="w-full flex flex-col gap-y-[20px]">
        <div className="w-full">
          <span className="inline-block text-sm font-medium text-primary-100 mb-[6px]">
            Category
          </span>

          <Controller
            control={control}
            name="category"
            render={({ field: { onChange, value } }) => (
              <DropDown
                menuItems={formattedPassedCategories}
                setValue={onChange}
                value={value}
                placeholder="Select Category"
              />
            )}
          />

          {errors.category && <ErrorMessageWithExclamation text={errors.category.message} />}
        </div>

        <div className="w-full">
          <label htmlFor="title" className="text-sm font-medium text-primary-100 mb-[6px]">
            Quiz Title
          </label>

          <Input
            type="text"
            id="title"
            className="text-primary-100"
            placeholder="Enter job post title (max. 100 characters)"
            {...register('quiz_title')}
          />

          {errors.quiz_title ? (
            <ErrorMessageWithExclamation text={errors.quiz_title.message} />
          ) : (
            <p className="mt-[8px] text-xs text-primary-button">
              This tittle is important for finding this quiz amongst other quizzes
            </p>
          )}
        </div>

        <div className="w-full flex flex-col">
          <span className="inline-block text-sm font-medium text-primary-100 mb-[6px]">
            Due Date to Pass the Quiz
          </span>

          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Controller
              control={control}
              name="due_date"
              render={({ field: { value, onChange } }) => {
                return (
                  <DatePicker
                    minDate={moment().add(1, 'day')}
                    maxDate={moment().add(100, 'year')}
                    value={value}
                    onChange={onChange}
                    className="custom-date-picker custom-date-picker--todo !w-full"
                    slotProps={{
                      textField: {
                        readOnly: true,
                      },
                    }}
                  />
                )
              }}
            />
          </LocalizationProvider>

          {errors.due_date && <ErrorMessageWithExclamation text={errors.due_date.message} />}
        </div>
      </div>

      <Button type="submit" className="w-full font-semibold mt-[24px]">
        Next
      </Button>

      <Link
        to={`/${role}/settings/my-quiz-templates`}
        className="text-base font-semibold text-[#F79009] hover:text-[#F79009] mx-auto mt-[16px]"
      >
        Cancel
      </Link>
    </form>
  )
}

export default MyQuizTemplateCreateForm
